import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import NavLinks from './NavLinks'; // Import the component for the tabs
import ViewStudent from './ViewStudent'; // Import your other components
import StudentFeeManagement from './fee_management/fee/StudentFeeManagement';
import StudentStatistics from './StudentStatistics';

const StudentDetailsHolder = () => {
  return (
    <div>
      {/* Render the tabs at the top of the page */}
      <NavLinks />

      {/* Define the routes that will render based on the selected tab */}
      <Routes>
        <Route path="view-student" element={<ViewStudent />} />
        <Route path="statistics" element={<StudentStatistics />} />
        <Route path="assign-fee" element={<StudentFeeManagement />} />

        {/* Default to "view-student" if no valid path is matched */}
        <Route path="*" element={<Navigate to="view-student" replace />} />
      </Routes>
    </div>
  );
};

export default StudentDetailsHolder;
